
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Statistics } from '@clients/bff';
import KeyDataTab from './KeyDataTab.vue';
import DiagramsTab from './DiagramsTab.vue';
import TimelinesTab from './TimelinesTab.vue';

@Component({
  name: 'StatisticTabsView',
  components: {
    KeyDataTab,
    DiagramsTab,
    TimelinesTab,
  },
})
export default class StatisticTabsView extends Vue {
  @Prop()
  private statistics: Statistics;

  @Prop()
  private selectedTab: number;

  @Prop()
  private loading: boolean;

  get statisticTabs() {
    return this.statistics.statisticTabs;
  }

  get ecoScore() {
    return this.statistics.statisticGraphics.ecoScore;
  }

  get keyDataSelected() {
    return this.selectedTab === 0;
  }

  get diagramsSelected() {
    return this.selectedTab === 1;
  }

  get timelinesSelected() {
    return this.selectedTab === 2;
  }

  selectKeyData() {
    this.$emit('tabSelected', 0);
  }

  selectDiagrams() {
    this.$emit('tabSelected', 1);
  }

  selectTimelines() {
    this.$emit('tabSelected', 2);
  }
}
